// extracted by mini-css-extract-plugin
export default {"formLabel":"DateRangeFilter_formLabel__JWgr9","formLabelContainer":"DateRangeFilter_formLabelContainer__O54PI"};